import { Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import Snackbar from '../../Snacbar'
import DSR_Services from "../../../Services/Reports/DSR_Services";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0.5),
  border: " 1px solid black",
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));

function DSR1() {
  const mystyle = {
    border: " 1px solid black",fontFamily: 'Times New Roman',
    width: "9rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",fontFamily: 'Times New Roman',
    color: "#0b64c5",
  };

  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [showProcs, setshowProcs] = useState(false)
  const [reportProcs, setreportProcs] = useState(false)
  const [clearProcs, setclearProcs] = useState(false)

  const [FilteredDetails, setFilteredDetails] = useState([])

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [details5, setdetails5] = useState([]);
  const [details6, setdetails6] = useState([]);
  const [dsr1Values, setdsr1Values] = useState({
    from: getDate(),
    to: getDate(),
    impnm: '-1',
    transit: '-1',
    port: '-1',
    branch: '-1',
    empnm: '-1',
    job: '-1',
    optype: '-1',
    //sumary
    totaljobNo: '0',
    totalpcs: '0',
    totalgrossWt: '0.00',
    totalChrgblWt: '0.00',
    totalInvValue: '0.00',
    totalAssesableValue: '0.00',
    totalDutyAmt: '0.00',
  });
  const fromhandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, to: e.target.value })
  };
  const impnmhandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, impnm: e.target.value })
  };
  const transithandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, transit: e.target.value })
  };
  const porthandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, port: e.target.value })
  };
  const branchhandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, branch: e.target.value })
  };
  const empnmhandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, empnm: e.target.value })
  };
  const jobhandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, job: e.target.value })
  };
  const optypehandlechange = (e) => {
    setdsr1Values({ ...dsr1Values, optype: e.target.value })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  //resetFunctions
  const summaryReset = () => {
    setdsr1Values({
      ...dsr1Values, totaljobNo: '0', totalpcs: '0', totalgrossWt: '0.00', totalChrgblWt: '0.00',
      totalInvValue: '0.00', totalAssesableValue: '0.00', totalDutyAmt: '0.00',
    })
  }
  //getfunctions
  const getFunctions = () => {
    DSR_Services.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails1(res.data);
    })
    // //gettransismode
    DSR_Services.getTransitAll().then(res => {
      setdetails2(res.data);
    })
    // //getclearanceport
    DSR_Services.getCustomLocation().then(res => {
      setdetails3(res.data);
    })
    //getBranchDetails
    DSR_Services.selectBranchDetails().then(res => {
      setdetails4(res.data);
    })
    //getempoyeName
    DSR_Services.getEmployeeDetails().then(res => {
      setdetails5(res.data);
    })
  }
  //buttonOperations==>
  const showBtnClick = () => {
    setloading(true)
    setshowProcs(true)
    setPage(0)
    summaryReset();
    var transTypCd, impcd, pointid, value, reginlid, empid, optype = '';
    if (dsr1Values.transit === 'ALL' || dsr1Values.transit === '') {
      transTypCd = '-1'
    } else {
      transTypCd = dsr1Values.transit;
    }
    if (dsr1Values.impnm === 'ALL') {
      impcd = '-1'
    } else {
      impcd = dsr1Values.impnm
    }
    if (dsr1Values.port === 'ALL') {
      pointid = '-1'
    } else {
      pointid = dsr1Values.port
    }
    if (dsr1Values.job === 'YES') {
      value = '1'
    } else if (dsr1Values.job === 'NO') {
      value = '0'
    } else {
      value = '-1'
    }
    if (dsr1Values.branch === 'ALL') {
      reginlid = '-1'
    } else {
      reginlid = dsr1Values.branch
    }
    if (dsr1Values.empnm === 'ALL') {
      empid = -1
    } else {
      empid = dsr1Values.empnm
    }
    if (dsr1Values.optype === 'ALL') {
      optype = '-1'
    } else {
      optype = dsr1Values.optype
    }
    let details = {
      fromDate: dsr1Values.from, toDate: dsr1Values.to, transitTypeCode: transTypCd, importer_iec_no: impcd, customPointCode: pointid,
      clearanceStatus: value, regionalId: reginlid, employeeId: empid, operationType: optype
    }
    DSR_Services.getDSR_Report(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      console.log('valuesssssss=>' + JSON.stringify(details))
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        var totJob, totPcs = 0, totGrsWt = 0, totChrWt = 0, totInval = 0, totAsbVal = 0, totDutyAmt = 0
        var jobCount = 0;
        var valueJob = "";
        for (let i = 0; i < details.length; i++) {
          if (details[i].consignmentNumber !== valueJob) {
            jobCount += 1;
            valueJob = details[i].consignmentNumber;
          }
          totJob = jobCount;

          totPcs += details[i].noofPkg
          totGrsWt += details[i].totalWeight
          totChrWt += details[i].chargeableWeight
          totInval += details[i].invoiceValue
          totAsbVal += Number(details[i].assbleValue)
          totDutyAmt += Number(details[i].dutyAmount)
        }
        setdsr1Values({
          ...dsr1Values, totaljobNo: totJob, totalpcs: totPcs, totalgrossWt: totGrsWt.toFixed(2),
          totalChrgblWt: totChrWt.toFixed(2), totalInvValue: totInval.toFixed(2), totalAssesableValue: totAsbVal.toFixed(2), totalDutyAmt: totDutyAmt.toFixed(2)
        })
        setdetails6(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
    setshowProcs(false)
  }
  const ReportBtnClick = () => {
    setreportProcs(true)
    if (!details6[0] || details6[0] === []) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details6.length; i++) {
        if (details6[i].regionalName !== '') {
          tableContent = details6[i].regionalName + "!"
        } else {
          tableContent += '   !'
        }
        if (details6[i].employeeName !== '') {
          tableContent += details6[i].employeeName + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details6[i].consignmentNumber !== '') {
          tableContent += details6[i].consignmentNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].transitDate !== '') {
          tableContent += details6[i].transitDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].importer_name !== '') {
          tableContent += details6[i].importer_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].item_description !== '') {
          tableContent += details6[i].item_description + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].transitTypeName !== '') {
          tableContent += details6[i].transitTypeName + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].mawbNo !== '') {
          tableContent += details6[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].hawb_no !== '') {
          tableContent += details6[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].containorNo !== '') {
          tableContent += details6[i].containorNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].containorSize !== '') {
          tableContent += details6[i].containorSize + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].invoiceNumber !== '') {
          tableContent += details6[i].invoiceNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].gatewayPortDate !== '') {
          tableContent += details6[i].gatewayPortDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].invoiceValue !== '') {
          tableContent += details6[i].invoiceValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].boe_no !== '') {
          tableContent += details6[i].boe_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].boe_date !== '') {
          tableContent += details6[i].boe_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].assbleValue !== '') {
          tableContent += details6[i].assbleValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].dutyAmount !== '') {
          tableContent += details6[i].dutyAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].noofPkg !== '') {
          tableContent += details6[i].noofPkg + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].totalWeight !== '') {
          tableContent += details6[i].totalWeight + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].chargeableWeight !== '') {
          tableContent += details6[i].chargeableWeight + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].clearanceDate !== '') {
          tableContent += details6[i].clearanceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].release_date !== '') {
          tableContent += details6[i].release_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].status !== '') {
          tableContent += details6[i].status + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].customPointName !== '') {
          tableContent += details6[i].customPointName + "!"
        } else {
          tableContent += '  !';
        }
        if (details6[i].totalBillAmount !== '') {
          tableContent += details6[i].totalBillAmount + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DSR REPORT", headerDetails: "1,1,FROM DATE : " + dsr1Values.from + "/4,1,TO DATE : " + dsr1Values.to,
        tableHeader: "0,3,Sl.No/1,3,Branch Name/2,3,Employee Name/3,3,Job No/4,3,Job Date/5,3,Party Name/6,3,Item Description/7,3,Transit Mode/8,3,MAWB_MBL No/9,3,HAWB_HBL No/10,3,Container No/11,3,Container Size/12,3,Invoice No/13,3,Estimate Arrival Date/14,3,Invoice Value/15,3,BOE No/16,3,BOE Date/17,3,Assessable value/18,3,Duty/19,3,No Of Pkg/20,3,Gross Weight/21,3,Chargeable Weight/22,3,Release Date/23,3,JobFileReceivedDate/24,3,Job Status/25,3,Clearance Port",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "dsr", totalNumberOfColumn: 26, tableContent: contenall.substring(0, contenall.length - 1),
      }
      DSR_Services.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setreportProcs(false)
  }
  const clearBtnClick = () => {
    setclearProcs(true)
    setdetails6([])
    setFilteredDetails([])
    setdsr1Values({
      ...dsr1Values, from: getDate(), to: getDate(), impnm: '-1', transit: '', port: '-1', branch: '-1', empnm: '-1', job: '-1',
      optype: '-1', totaljobNo: '0', totalpcs: '0', totalgrossWt: '0.00', totalChrgblWt: '0.00',
      totalInvValue: '0.00', totalAssesableValue: '0.00', totalDutyAmt: '0.00',
    })
    setclearProcs(false)
  }
  ///
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getFunctions();
  }, []);

  //table search

  const branchNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { branchNmOnchange(e.target.value) }} />
  }
  const empSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { empOnchange(e.target.value) }} />
  }
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const partyNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { partyNmOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { modeSrchOnchange(e.target.value) }} />
  }
  const containerNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { containerNoOnchange(e.target.value) }} />
  }
  const billNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { billNoOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { invcNoOnchange(e.target.value) }} />
  }
  const boeNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { boeNoOnchange(e.target.value) }} />
  }
  const jobStsSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobStsOnchange(e.target.value) }} />
  }
  const clrPortSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { clrPortOnchange(e.target.value) }} />
  }

  //
  const branchNmOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const empOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.employeeName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const partyNmOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeSrchOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.transitTypeName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const containerNoOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.containorNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const billNoOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.bill_no.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invcNoOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.invoiceNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const boeNoOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.boe_no.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobStsOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.status.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const clrPortOnchange = (searchedVal) => {
    const filteredvalue = details6.filter((trns) => {
      return trns.customPointName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details6)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Grid container>
              <Grid item xs={8}>
                <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>DSR-1 REPORT</center></div>
                <Row>
                  <Col xs={3}>
                    <label style={mystyle1}>FromDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={dsr1Values.from} onChange={fromhandlechange} />
                  </Col>
                  <Col>
                    <label style={mystyle1}>ToDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={dsr1Values.to} onChange={tohandlechange} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>ImporterName</label>
                  </Col>
                  <Col>
                    <Form.Select type="text" list="code" style={mystyle} size="sm" value={dsr1Values.impnm} onChange={impnmhandlechange}>
                      <option value={'-1'}>ALL</option>
                      {details1.map(trns => (
                        <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>TransitType</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.transit} onChange={transithandlechange}>
                      {details2.map(trns => (
                        <option value={trns.transitTypeCode}>{trns.transitTypeName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>ClearancePort</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.port} onChange={porthandlechange}>
                      <option value={'-1'}>ALL</option>
                      {details3.map(trns => (
                        <option value={trns.clearanceLocationCode}>{trns.clearanceLocationName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>BranchName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.branch} onChange={branchhandlechange}>
                      {details4.map(trns => (
                        <option value={trns.regionId}>{trns.regionalName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>EmployeeName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.empnm} onChange={empnmhandlechange}>
                      {details5.map(trns => (
                        <option value={trns.employeeId}>{trns.employeeName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>JobRelStatus</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.job} onChange={jobhandlechange}>
                      <option value={'-1'}>ALL</option>
                      <option value={'YES'}>YES</option>
                      <option value={'NO'}>NO</option>
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>OperationType</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={dsr1Values.optype} onChange={optypehandlechange}>
                      <option value={'-1'}>ALL</option>
                      <option value={'IMPORT'}>IMPORT</option>
                      <option value={'EXPORT'}>EXPORT</option>
                      <option value={'COURIER'}>COURIER</option>
                    </Form.Select>
                  </Col>
                </Row>
                <center><Col lg={5} className='mt-2'>
                  <Button variant="primary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'}</Button>{" "}
                  <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={ReportBtnClick}> {reportProcs ? 'processing...' : 'Report'} </Button>{" "}
                  <Button variant="danger" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={clearBtnClick}> {clearProcs ? 'processing...' : 'Reset'} </Button>
                </Col></center>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    Summary
                  </Typography>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalJobNo</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totaljobNo}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalPcs</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalpcs}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalGrossWT</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalgrossWt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalChargeableWT</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalChrgblWt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalInvoiceValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalInvValue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>Total AssessableValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalAssesableValue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalDutyAmt</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{dsr1Values.totalDutyAmt}</Form.Label></Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            <ItemPap1>
              <TableContainer sx={{ height: 300 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>BranchName{branchNmSrch()}</StyledTableCell>
                      <StyledTableCell>Employee{empSrch()}</StyledTableCell>
                      <StyledTableCell>OperationType</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobDate</StyledTableCell>
                      <StyledTableCell>PartyName{partyNmSrch()}</StyledTableCell>
                      <StyledTableCell>ItemDescription</StyledTableCell>
                      <StyledTableCell>Mode{modeSrch()}</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>ContainerNo{containerNoSrch()}</StyledTableCell>
                      <StyledTableCell>ContainerSize</StyledTableCell>
                      <StyledTableCell>BillNo{billNoSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>Est_ArrivalDate</StyledTableCell>
                      <StyledTableCell>InvoiceValue</StyledTableCell>
                      <StyledTableCell>BOE_No{boeNoSrch()}</StyledTableCell>
                      <StyledTableCell>BOE_Date</StyledTableCell>
                      <StyledTableCell>Assessable_Value</StyledTableCell>
                      <StyledTableCell>Duty</StyledTableCell>
                      <StyledTableCell>NoOfPkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>Chargebale_WT</StyledTableCell>
                      <StyledTableCell>ReleaseDate</StyledTableCell>
                      <StyledTableCell>DateOfJobFile</StyledTableCell>
                      <StyledTableCell>JobStatus{jobStsSrch()}</StyledTableCell>
                      <StyledTableCell>ClearancePort{clrPortSrch()}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.employeeName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.item_description}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitTypeName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containorNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containorSize}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.bill_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gatewayPortDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.assbleValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noofPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.chargeableWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clearanceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.release_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.status}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.customPointName}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default DSR1;
